module.exports = __webpack_public_path__ + "static/media/deni-2.6d48e37d.jpg";